import { useMemo } from "react";

type FormatDateDisplayOptions = {
  dateOnly?: boolean;
};

export function useFormatDateDisplay() {
  const kyivDateFormatter = useMemo(
    () =>
      new Intl.DateTimeFormat("uk-UA", {
        timeZone: "Europe/Kyiv",
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
        hour12: false,
      }),
    [],
  );

  const kyivDateOnlyFormatter = useMemo(
    () =>
      new Intl.DateTimeFormat("uk-UA", {
        timeZone: "Europe/Kyiv",
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
      }),
    [],
  );

  return (createdAt: string, options?: FormatDateDisplayOptions): string => {
    const s = createdAt.trim();
    const toDisplay = (dt: Date) => (options?.dateOnly ? kyivDateOnlyFormatter.format(dt) : kyivDateFormatter.format(dt).replace(",", ""));

    const ymdHm = s.match(/^(\d{4})-(\d{2})-(\d{2})(?:[ T](\d{2}):(\d{2})(?::\d{2})?)?$/);
    if (ymdHm) {
      const [, y, m, d, h = "00", min = "00"] = ymdHm;
      const utcDate = new Date(Date.UTC(Number(y), Number(m) - 1, Number(d), Number(h), Number(min)));
      return toDisplay(utcDate);
    }

    const dmyHm = s.match(/^(\d{2})\.(\d{2})\.(\d{4})(?:[ ,](\d{2}):(\d{2})(?::\d{2})?)?$/);
    if (dmyHm) {
      const [, d, m, y, h = "00", min = "00"] = dmyHm;
      const utcDate = new Date(Date.UTC(Number(y), Number(m) - 1, Number(d), Number(h), Number(min)));
      return toDisplay(utcDate);
    }

    const hasTimezone = /(?:Z|[+-]\d{2}:?\d{2})$/i.test(s);
    if (hasTimezone) {
      const parsed = Date.parse(s);
      if (!Number.isNaN(parsed)) return toDisplay(new Date(parsed));
    }

    return s;
  };
}
